export default __webpack_public_path__ + "static/media/diagonal.2ca8d37d.png";